import axios from "./axios";
import { errorToast, successToast } from "../shared/Toast";

// Admin CRUD for the Apps entity (app identity, status, version fields, and the
// merchant allow-list). Backend responses follow { isError, message, data }.

const fetchApps = async (search = "") => {
  try {
    const response = await axios.get("/api/admin/apps", {
      params: search ? { search } : {},
    });
    const responseData = response?.data;
    if (responseData?.isError === false) {
      return responseData?.data || [];
    }
    errorToast(responseData?.message ?? "Error loading apps");
    return [];
  } catch (error) {
    console.error("Error fetching apps:", error);
    errorToast(error?.response?.data?.message ?? "Error loading apps");
    return [];
  }
};

const getApp = async (appId) => {
  try {
    const response = await axios.get(`/api/admin/apps/${appId}`);
    const responseData = response?.data;
    if (responseData?.isError === false) {
      return responseData?.data;
    }
    errorToast(responseData?.message ?? "Error loading app");
    return null;
  } catch (error) {
    console.error("Error fetching app:", error);
    errorToast(error?.response?.data?.message ?? "Error loading app");
    return null;
  }
};

const createApp = async (payload) => {
  try {
    const response = await axios.post("/api/admin/apps", payload);
    if (response?.data?.isError === false) {
      successToast(response?.data?.message ?? "App created");
      return response?.data?.data;
    }
    errorToast(response?.data?.message ?? "Error creating app");
    return null;
  } catch (error) {
    console.error("Error creating app:", error);
    errorToast(error?.response?.data?.message ?? "Error creating app");
    return null;
  }
};

const editApp = async (appId, payload) => {
  try {
    const response = await axios.put(`/api/admin/apps/${appId}`, payload);
    if (response?.data?.isError === false) {
      successToast(response?.data?.message ?? "App updated");
      return response?.data?.data;
    }
    errorToast(response?.data?.message ?? "Error updating app");
    return null;
  } catch (error) {
    console.error("Error updating app:", error);
    errorToast(error?.response?.data?.message ?? "Error updating app");
    return null;
  }
};

// Reused for the merchant multi-select source.
const fetchMerchantsForApps = async () => {
  try {
    const response = await axios.get("/api/merchant/getMerchantsList");
    if (response?.data?.isError === false) {
      return response?.data?.data || [];
    }
    return [];
  } catch (error) {
    console.error("Error fetching merchants:", error);
    return [];
  }
};

export { fetchApps, getApp, createApp, editApp, fetchMerchantsForApps };
